"use client";

// Compat shim. The backend now owns the trash workflow — listJobsForUser
// already excludes trashed audits, so the dashboard's old client-side
// filter (`!isInTrash(j.id)`) becomes a no-op. trashJob fires a real
// DELETE which the backend treats as a soft-trash.

import { deleteJob } from "./api";
import { readToken } from "./auth";

/** Always false — the server filters trashed audits out of the list. */
export function isInTrash(id: string): boolean {
  void id;
  return false;
}

/** Move an audit to the trash on the backend. Best-effort, fire-and-forget.
 *  Accepts either a job id or any object with an `id` field for backwards
 *  compatibility with the dashboard caller. */
export function trashJob(jobOrId: string | { id: string }): void {
  const token = readToken();
  if (!token) return;
  const id = typeof jobOrId === "string" ? jobOrId : jobOrId.id;
  void deleteJob(token, id).catch((err) => {
    console.warn("[trash] trashJob failed", err);
  });
}
